import React from 'react'
import './itemAdded.css'

const ItemAdded = () => {
  return (
    <div className='item-added' >
        <p>Item Added To Cart</p>
    </div>
  )
}

export default ItemAdded